export interface TypingIndicatorProps {
  /** Pre-composed, e.g. "The Wayfarer Family is typing" — the caller owns the i18n key. */
  label: string;
}

const DOT = "size-[5px] animate-typing-dot rounded-full bg-neutral-500 motion-reduce:animate-none";

/**
 * Stands in for a message that has not arrived, so it sits in the thread where that message will:
 * same pill geometry as a bubble, same side as the speaker. The staggered delays make the three
 * dots read as one travelling wave rather than three independent blinks.
 */
export function TypingIndicator({ label }: TypingIndicatorProps) {
  return (
    <div className="flex h-8 w-fit items-center gap-1 rounded-full bg-neutral-50 px-3.5" role="status">
      <span className="sr-only">{label}</span>
      <span className={DOT} />
      <span className={`${DOT} [animation-delay:150ms]`} />
      <span className={`${DOT} [animation-delay:300ms]`} />
    </div>
  );
}
